import { FC } from 'react';

import { IcChevron24Icon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconView, SelectableListItem } from '@gem/ui-kit';

import { UnauthorizedLayoutTemplate } from 'APP/components/UnauthorizedLayoutTemplate/UnauthorizedLayoutTemplate';

import { LoginRegionSupportInfo } from '../../../components/LoginRegionSupportInfo/LoginRegionSupportInfo';
import {
  ILoginDestinationTypeStepProps,
  useLoginDestinationTypeStepPresenter,
} from './LoginDestinationTypeStep.presenter';
import styles from './LoginDestinationTypeStep.styles.m.css';

export const LoginDestinationTypeStep: FC<ILoginDestinationTypeStepProps> = (props) => {
  const presenter = useLoginDestinationTypeStepPresenter(props);
  const { t } = useTranslation();
  const { loginPresenter } = props;

  return (
    <UnauthorizedLayoutTemplate
      onBack={loginPresenter.onBackHandler || undefined}
      title={t('auth_connection_method_title')}
      info={<LoginRegionSupportInfo />}
      message={loginPresenter.errorMessage}
    >
      {presenter.items.map((item) => (
        <SelectableListItem
          icon={<item.Illustration className={styles.illustration} />}
          className={styles.item}
          key={item.type}
          onClick={item.onClick}
          title={item.title}
          secondaryTitle={item.description}
          size="medium-1"
          suffix={
            <IconView
              className={styles.arrowIcon}
              Icon={IcChevron24Icon}
              theme="inherit"
            />
          }
        />
      ))}
    </UnauthorizedLayoutTemplate>
  );
};
